import {
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles
} from "@material-ui/core";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import useNotifier from "@saleor/hooks/useNotifier";
import useUser from "@saleor/hooks/useUser";
import { findValueInEnum, maybe } from "@saleor/misc";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import { StoreTypeEnum } from "@saleor/types/globalTypes";
import React, { Fragment, useState } from "react";

import { BusinessDetailsForm } from "./../../components/BusinessDetailsForm";
import Validate from "./../../controllers/CustomValidation";
import { BrandCreateMutation } from "./../../mutations";
import { BrandCreate } from "./../../types/BrandCreate";
import { BusinessPageFormData } from "./../BusinessDetailsPage";
const useStyles = makeStyles(
  {
    bdloader: {
      alignItems: "center",
      backgroundColor: "rgba(255, 255, 255, .5)",
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      left: 0,
      position: "fixed",
      right: 0,
      top: 0,
      zIndex: 99
    },
    frmAction: {
      justifyContent: "center"
    },
    frmBtn: {
      "&.active": {
        "& span": {
          color: "#fff"
        },
        backgroundColor: "#285BAD"
      },
      "&:hover": {
        "& span": {
          color: "#fff"
        },
        backgroundColor: "#285BAD"
      },
      color: "#0030FF",
      padding: "6px 30px"
    },
    frmDialog: {
      zIndex: 999
    },
    frmTxt: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      fontSize: "18px",
      justifyContent: "center",
      minHeight: "100px",
      textAlign: "center"
    }
  },
  { name: "BrandCreatePage" }
);

export interface BrandCreatePageProp {
  onBack: () => void;
  setHasBrand: any;
}

export const BrandCreatePage: React.FC<BrandCreatePageProp> = ({
  onBack,
  setHasBrand
}) => {
  const classes = useStyles({});
  const notify = useNotifier();
  const { user } = useUser();
  const [open, setOpen] = useState(false);
  const [brandID, setBrandID] = useState(null);
  const [validations, setValidation] = useState({
    err: {},
    err_msg: []
  });

  const initialForm: BusinessPageFormData = {
    bankAccountName: "",
    bankAccountNo: "",
    bankName: "",
    completeAddress: "",
    financeEmail: "",
    financeMobileNo: "",
    financeName: "",
    legalName: "",
    name: "",
    signatoryDesignation: "",
    signatoryEmail: "",
    signatoryMobileNo: "",
    signatoryName: "",
    storeType: "",
    swornDeclarationsFlag: null,
    tinNo: ""
  };
  const [loader, setLoader] = useState(false);
  const handleBrandCreate = (data: BrandCreate) => data;
  const clickYesButton = () => {
    setOpen(false);
    setHasBrand(brandID);
  };
  return (
    <BrandCreateMutation onCompleted={handleBrandCreate}>
      {brandCreate => {
        const handleSubmit = async (data: BusinessPageFormData) => {
          setLoader(true);
          setValidation({
            err: {},
            err_msg: []
          });
          const initValidations = {
            bankAccountName: { required: true, usename: "Bank Account Name" },
            bankAccountNo: { required: true, usename: "Bank Account No" },
            bankName: { required: true, usename: "Bank Name" },
            financeEmail: {
              email: true,
              required: true,
              usename: "Finance Email"
            },
            financeMobileNo: { required: true, usename: "Finance Mobile No" },
            financeName: { required: true, usename: "Finance Name" },
            legalName: { required: true, usename: "Company Name" },
            name: { required: true, usename: "Lease Name" },
            signatoryEmail: {
              email: true,
              required: true,
              usename: "Signatory Email"
            },
            signatoryMobileNo: {
              required: true,
              usename: "Signatory Mobile No"
            },
            signatoryName: { required: true, usename: "Signatory Name" },
            storeType: {
              required: true,
              usename: "Store Type"
            },
            tinNo: { required: true, usename: "Tin No" }
          };
          //   console.log(data);
          const {
            validation_errors,
            validation_has_error,
            validation_message
          } = await Validate(initValidations, data);
          if (validation_has_error) {
            const timer = setTimeout(() => {
              setValidation({
                err: validation_errors,
                err_msg: validation_message
              });
              notify({
                status: "error",
                text: "Invalid Form! Please complete the fields"
              });
              setLoader(false);
              return false;
            }, 1500);
            return () => clearTimeout(timer);
          }
          // console.log(user);
          // console.log(data);
          const brand_result = await brandCreate({
            variables: {
              input: {
                attachTo: user.id,
                bankAccountName: data.bankAccountName,
                bankAccountNo: data.bankAccountNo,
                bankName: data.bankName,
                completeAddress: data.completeAddress,
                financeEmail: data.financeEmail,
                financeMobileNo: data.financeMobileNo,
                financeName: data.financeName,
                legalName: data.legalName,
                name: data.name,
                signatoryDesignation: data.signatoryDesignation,
                signatoryEmail: data.signatoryEmail,
                signatoryMobileNo: data.signatoryMobileNo,
                signatoryName: data.signatoryName,
                status: maybe(() => findValueInEnum("RVW", SmopStatusEnum)),
                storeType: maybe(() =>
                  findValueInEnum(data.storeType, StoreTypeEnum)
                ),
                swornDeclarationsFlag: data.swornDeclarationsFlag,
                tinNo: data.tinNo
              }
            }
          });

          // console.log(brand_result.data.brandCreate);
          const { brand, errors } = brand_result.data.brandCreate;
          if (errors && errors.length) {
            setLoader(false);
            notify({
              status: "error",
              text: "Invalid Form! Please complete the fields"
            });
            return false;
          }
          setBrandID(brand.id);
          setLoader(false);
          setOpen(true);
          return null;
        };
        return (
          <Fragment>
            {loader && (
              <div className={classes.bdloader}>
                <CircularProgress size={150} />
              </div>
            )}
            <Form initial={initialForm} onSubmit={handleSubmit} confirmLeave>
              {({ data, change, submit, hasChanged }) => (
                <Container>
                  <Grid>
                    <BusinessDetailsForm
                      validations={validations}
                      data={data}
                      onChange={change}
                    />
                  </Grid>

                  <div>
                    <SaveButtonBar
                      state={undefined}
                      onCancel={onBack}
                      onSave={submit}
                      disabled={!hasChanged}
                    />
                  </div>
                </Container>
              )}
            </Form>
            <Dialog
              open={open}
              onClose={() => clickYesButton()}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className={classes.frmDialog}
            >
              <DialogContent className={classes.frmTxt}>
                Thank You For Your Application! <br />
                We’ll get back to you as we review and activate your account
              </DialogContent>
              <DialogActions className={classes.frmAction}>
                <Button
                  className={classes.frmBtn + " active"}
                  id="btnYes"
                  color="primary"
                  type="button"
                  onClick={() => clickYesButton()}
                >
                  Okay
                </Button>
              </DialogActions>
            </Dialog>
          </Fragment>
        );
      }}
    </BrandCreateMutation>
  );
};
export default BrandCreatePage;
